import { render } from "./StudentUserOrderDetail.vue?vue&type=template&id=59e2b95f&scoped=true"
import script from "./StudentUserOrderDetail.vue?vue&type=script&lang=js"
export * from "./StudentUserOrderDetail.vue?vue&type=script&lang=js"

import "./StudentUserOrderDetail.vue?vue&type=style&index=0&id=59e2b95f&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.1.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59e2b95f"]])

export default __exports__